"use strict";
/**
 * Mapping between internal raceTeamId values and ADMAPI series names.
 * Used across client and server when integrating with the GM Motorsports ADMAPI.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTeamsForSeries = exports.getSeriesNameForTeam = exports.SERIES_TO_TEAMS = exports.TEAM_TO_SERIES = void 0;
/** Map from raceTeamId to ADMAPI series name */
exports.TEAM_TO_SERIES = {
    'NASCAR-Cup': 'Cup',
    'NASCAR-Cup-28': 'Cup',
    '26-sub': 'Cup',
    'NASCAR-Truck': 'Truck',
    'NASCAR-NBS': 'NBS',
    'NBS-HFT': 'NBS',
    lmdh: 'LMDH',
    indycar: 'IndyCar',
    'IndyCar-28': 'IndyCar',
    'testing-team': 'IndyCar',
    'testing-team-dev': 'IndyCar'
};
/** Map from ADMAPI series name to raceTeamId(s) — reverse lookup */
exports.SERIES_TO_TEAMS = Object.entries(exports.TEAM_TO_SERIES).reduce((acc, [team, series]) => {
    if (!acc[series])
        acc[series] = [];
    acc[series].push(team);
    return acc;
}, {});
/**
 * Resolve the ADMAPI series name for a given raceTeamId.
 * Tries exact match first, then strips common environment suffixes (-dev, -staging, -prod).
 */
const getSeriesNameForTeam = (raceTeamId) => {
    if (exports.TEAM_TO_SERIES[raceTeamId])
        return exports.TEAM_TO_SERIES[raceTeamId];
    const base = raceTeamId.replace(/-(dev|staging|prod)$/i, '');
    if (exports.TEAM_TO_SERIES[base])
        return exports.TEAM_TO_SERIES[base];
    return undefined;
};
exports.getSeriesNameForTeam = getSeriesNameForTeam;
/**
 * Resolve the primary raceTeamId(s) for a given ADMAPI series name.
 */
const getTeamsForSeries = (seriesName) => {
    return exports.SERIES_TO_TEAMS[seriesName] || [];
};
exports.getTeamsForSeries = getTeamsForSeries;
